import React from "react";
import { Route, Switch, Redirect } from 'react-router-dom';
import asyncComponent from '../../../itrust_common/components/AsyncComponent';

const WalletTopUpLogsWrap = asyncComponent(() =>
  import('../../../components/authorised/marketingBlast/walletAndBilling/WalletTopUpLogsWrap')
)

// const CampaignPaymentLogs = asyncComponent(() =>
//   import('../../../components/authorised/marketingBlast/walletAndBilling/campaignBilling/CampaignBillingLogs')
// )

const WalletAndBillingRoutes = (
  <Switch>
    <Route exact path='/marketing-blast/wallet/logs' component={WalletTopUpLogsWrap} />
    {/* <Route exact path='/marketing-blast/wallet/campaign-payments-logs' component={CampaignPaymentLogs} /> */}
    <Redirect exact from="/marketing-blast/wallet" to="/marketing-blast/wallet/logs" />
  </Switch>
)

export default WalletAndBillingRoutes;